module.exports = __webpack_public_path__ + "img/white-block-left.45c9fbe2.png";